import { render } from "./ReportItem.vue?vue&type=template&id=5615c4db&scoped=true"
import script from "./ReportItem.vue?vue&type=script&lang=js"
export * from "./ReportItem.vue?vue&type=script&lang=js"

import "./ReportItem.vue?vue&type=style&index=0&id=5615c4db&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5615c4db"]])

export default __exports__